import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImages } from "@fortawesome/free-solid-svg-icons";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const Hero = () => {
	return (
		<section>
			<img id="hero-img" className="absolute h-screen w-screen top-0 -z-50" src="./assets/Hero-Img.jpg" alt="" />
			<div id="hero-title-container" className="relative grid grid-flow-row place-content-center h-[90vh] content-between">
				<h1 id="hero-title" className="absolute  top-1/2 text-[25vw] font-diwan text-white lg:text-[12rem]">
					عصام الأشهب
				</h1>
				<Link to="/gallery" className="justify-self-center self-end text-center">
					<h2 className=" text-lightBrown text-3xl">الصور</h2>
					<FontAwesomeIcon icon={faImages} style={{ color: "#eac595", width: "100%", height: "50px" }} />
					<FontAwesomeIcon icon={faChevronDown} style={{ color: "#ffffff" }} />
				</Link>
			</div>
		</section>
	);
};

export default Hero;
